import { UpdateAvatarFileDialog } from '../../../component/ui/search-users/compoenents/update-avatar-file-dialog/update-avatar-file-dialog';
import { Avatar } from 'primereact/avatar';
import { UserType } from '../../../api/types/user/user-type';
import React, { useState } from 'react';
import { UserSummaryType } from '../../../api/types/user/user-summary.type';
import StudentIcon from '../../../assets/icons/search/student-icon.svg';
import LecturerIcon from '../../../assets/icons/search/lecturer-icon.svg';
import AdministrationIcon from '../../../assets/icons/search/administration-icon.svg';

interface UserPageHeaderDatamodel {
  selectedUser: UserSummaryType | undefined;
  setSelectedUser: (user: UserSummaryType | undefined) => any;
  userRole: UserType | undefined;
}

export const UserPageHeader: React.FC<UserPageHeaderDatamodel> = ({
  selectedUser,
  setSelectedUser,
  userRole,
}) => {
  const [addAvatar, setAddAvatar] = useState(false);

  const getIconByUserRole = (userRole: UserType) => {
    switch (userRole) {
      case UserType.ADMINISTRATION:
        return AdministrationIcon;
      case UserType.LECTURER:
        return LecturerIcon;
      case UserType.STUDENT:
        return StudentIcon;
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
      }}
    >
      <UpdateAvatarFileDialog
        shouldUploadFile={true}
        userId={selectedUser?.id}
        addAvatar={addAvatar}
        setAddAvatar={setAddAvatar}
        setSelectedUser={setSelectedUser}
        onFinishUploadFile={() => {
          setAddAvatar(false);
        }}
      />
      <Avatar
        image={selectedUser?.fileUrl}
        onClick={() => setAddAvatar(true)}
        label={
          selectedUser
            ? selectedUser.firstName.charAt(0) + selectedUser.lastName.charAt(0)
            : ''
        }
        size="xlarge"
        shape="circle"
      />
      <div style={{ marginRight: '8px' }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          {selectedUser && (
            <img
              style={{ marginLeft: '4px' }}
              src={getIconByUserRole(selectedUser.role)}
              height={18}
            />
          )}
          <div>
            {selectedUser?.firstName} {selectedUser?.lastName}
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center', // Aligns items vertically at the center
          }}
        >
          <div
            style={{
              fontSize: '16px',
              fontWeight: 'normal',
              marginRight: '4px',
            }}
          >
            {userRole === UserType.ADMINISTRATION
              ? 'מנהלה'
              : userRole === UserType.LECTURER
                ? 'מרצה'
                : 'סטודנט'}
          </div>
        </div>
      </div>
    </div>
  );
};
